import { IAppState } from '@store/model';
import { createSelector } from 'reselect';

export const selectCategories = (state: IAppState) => state.categories;

export const selectCategoriesData = createSelector(
  selectCategories,
  (categories) => categories.records,
);
